/* ============================================================
   CELESTIAL VAULT — custom sort dropdown
   Progressive enhancement: turns Dawn's native <select name="sort_by">
   into a dark, gold-accented custom dropdown. The native select stays
   in the DOM (visually hidden) so ALL of Dawn's sort wiring — AJAX
   re-render + ?sort_by= URL param — keeps working. Degrades to the
   native select if JS is unavailable.
   ============================================================ */
(function () {
  'use strict';

  function buildFor(select) {
    if (select.dataset.cvEnhanced === '1') return;
    select.dataset.cvEnhanced = '1';

    var wrap = document.createElement('div');
    wrap.className = 'cv-sort';
    wrap.dataset.open = 'false';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'cv-sort__btn';
    btn.setAttribute('aria-haspopup', 'listbox');
    btn.setAttribute('aria-expanded', 'false');

    var label = document.createElement('span');
    label.className = 'cv-sort__current';
    var chev = document.createElement('span');
    chev.className = 'cv-sort__chev';
    chev.setAttribute('aria-hidden', 'true');
    chev.innerHTML = '&#9662;';
    btn.appendChild(label);
    btn.appendChild(chev);

    var panel = document.createElement('div');
    panel.className = 'cv-sort__panel';
    panel.setAttribute('role', 'listbox');

    function syncLabel() {
      var opt = select.options[select.selectedIndex];
      label.textContent = opt ? opt.textContent.trim() : '';
      panel.querySelectorAll('.cv-sort__opt').forEach(function (el) {
        var on = el.dataset.value === select.value;
        el.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    }

    Array.prototype.forEach.call(select.options, function (option) {
      var opt = document.createElement('div');
      opt.className = 'cv-sort__opt';
      opt.setAttribute('role', 'option');
      opt.dataset.value = option.value;
      opt.textContent = option.textContent.trim();
      opt.addEventListener('click', function () {
        if (select.value !== option.value) {
          select.value = option.value;
          // Drive Dawn's existing handlers (AJAX sort + URL param).
          select.dispatchEvent(new Event('input', { bubbles: true }));
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
        syncLabel();
        setOpen(false);
      });
      panel.appendChild(opt);
    });

    function setOpen(v) {
      wrap.dataset.open = v ? 'true' : 'false';
      btn.setAttribute('aria-expanded', v ? 'true' : 'false');
    }
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      setOpen(wrap.dataset.open !== 'true');
    });
    wrap.addEventListener('click', function (e) { e.stopPropagation(); });

    wrap.appendChild(btn);
    wrap.appendChild(panel);
    select.parentNode.insertBefore(wrap, select.nextSibling);
    select.classList.add('cv-sort__native');
    syncLabel();

    // Keep label in sync if Dawn updates the select value programmatically.
    select.addEventListener('change', syncLabel);
  }

  function enhanceAll(root) {
    (root || document).querySelectorAll('select[name="sort_by"]').forEach(buildFor);
  }

  // Global close handlers (bound once)
  document.addEventListener('click', function () {
    document.querySelectorAll('.cv-sort[data-open="true"]').forEach(function (w) {
      w.dataset.open = 'false';
      var b = w.querySelector('.cv-sort__btn');
      if (b) b.setAttribute('aria-expanded', 'false');
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.cv-sort[data-open="true"]').forEach(function (w) {
        w.dataset.open = 'false';
      });
    }
  });

  function init() { enhanceAll(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Defensive retries + load fallback (covers async re-renders / races)
  window.addEventListener('load', init);
  setTimeout(init, 300);
  setTimeout(init, 1200);

  // Re-enhance after Dawn AJAX re-renders facets / theme editor reloads.
  document.addEventListener('shopify:section:load', function (e) { enhanceAll(e.target); });
  var debounce;
  new MutationObserver(function () {
    clearTimeout(debounce);
    debounce = setTimeout(enhanceAll, 120);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
